/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 2.52 PM
 */
import { api } from 'utils/index';

const defaultState = {
    items: [],
    meta: { total: 0, per_page: 0, current_page: 0 },
    statistic: { total: 0, meta: {} },
    errors: null,
};


function trigger(response, download = false) {
    const element = document.createElement('a');
    element.href = response;
    if (download) {
        element.download = 'Summary';
    }
    element.target = '_blank';
    element.click();
}


export default {
    name: 'order',
    state: defaultState,
    reducers: {
        reset: (state) => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({ ...state, items: payload.data, meta: payload.meta }),
        fetchStatisticResponse: (state, payload) => ({ ...state, statistic: payload }),
        printSummaryResponse: (state, payload) => {
            trigger(payload, true);
            return { ...state };
        },
        printReceiverResponse: (state, payload) => {
            trigger(payload, false);
            return { ...state };
        },
    },
    effects: {
        async fetch(params) {
            await api.get('orders', { params })
                .then((response) => this.fetchResponse(response));
        },

        async fetchStatistic(params) {
            await api.get('orders/statistics', { params })
                .then((response) => this.fetchStatisticResponse(response));
        },

        async printSummary(params) {
            await api.get('orders/print/summary', { params })
                .then((response) => this.printSummaryResponse(response));
        },

        async printReceiver(params) {
            await api.get('orders/print/receiver', { params })
                .then((response) => this.printReceiverResponse(response));
        },
    },
    selectors: (slice, createSelector) => ({
        all() {
            return createSelector(slice, (state) => state.orders, (order) => order.items);
        },
    }),
};
